:host {
  display: inline-block;
  width: auto;
  height: auto;
}

img {
  height: 100%;
}
